import React, { useMemo } from "react";
import { ClientViewTalentProfile } from "./TalentProfilePage";
import { Route, Routes, useLocation, useParams } from "react-router-dom";
import LoadingBanner from "../../components/LoadingBanner";
import PageError from "../../components/errors/PageError";
import ResourceNotFound from "../../components/errors/ResourceNotFound";
import { useAPI } from "../../config/API";

import {
    TalentProfileWorkHighlights,
    TalentProfileCertifications,
    TalentProfileAwards,
    AgencyProfileDetails,
    TalentProfileMembers,
    AgencyProfileServicesOffered,
    TalentProfileBrandExperience,
    AgencyProfilePartnerPrograms,
    AgencyProfileWorkGallery,
    AgencyProfileLocations,
    AgencyProfileTeams,
    AgencyProfileAboutUs,
} from './sections';

import ProfileLayoutWrapper from "./ProfileLayoutWrapper";

const components = {
    assets: { title: 'Work Gallery', element: AgencyProfileWorkGallery },
    service_offerings: { title: 'Services Offered', element: AgencyProfileServicesOffered },
    partnerable_programs: { title: 'Partnerships', element: AgencyProfilePartnerPrograms },
    // industries_worked: { title: 'Industry Experience', element: TalentProfileIndustryExperience },
    brands: { title: 'Brands', element: TalentProfileBrandExperience },
    key_clients: { title: 'Project Highlights', element: TalentProfileWorkHighlights },
    supplied_teams: { title: 'Teams', element: AgencyProfileTeams },
    members: { title: 'Individuals', element: TalentProfileMembers, itemsFunc: agency => (!agency.supplied_talent_users?.length && !agency.positions?.length) ? [] : ({ members: agency.supplied_talent_users || [], featuredMembers: agency.positions }) },
    // skills: { title: 'Skills', element: TalentProfileSkills },
    // talent_references: { title: 'References', element: TalentProfileReferences },
    // schools: { title: 'Education', element: TalentProfileEducation },
    // jobs: { title: 'Work History', element: TalentProfileWorkHistory },
    certifications: { title: 'Certifications', element: TalentProfileCertifications },
    awards: { title: 'Awards', element: TalentProfileAwards },
    locations: { title: 'Locations', element: AgencyProfileLocations, itemsFunc: agency => TB.uniqBy(([...(agency.location !== undefined ? [agency.location] : []),  ...agency.locations]) || [], 'id') },
    about_us: { title: 'About Us', element: AgencyProfileAboutUs, itemsFunc: agency => TB.pick(agency, ['about', 'is_black_owned', 'is_woman_owned', 'size', 'website' ]) },
}


const AgencyProfileLayout = ({ agency, isLoading, children }) => {

    const profileNavItems = useMemo(() => {
        if (isLoading || !agency) return [];

        let items = [];

        // if (talent.matching) {
        //     items.push({
        //         title: 'Match Score',
        //         element: TalentProfileMatchScore
        //     })
        // }

        // Object.keys(components).forEach(key => {
        //     if (key === 'members') {
        //         items.push({ ...components[key], items: { members: agency.supplied_talent_users || [], featuredMembers: agency.positions } })
        //     } else if (agency[key]?.length) {
        //         items.push({ ...components[key], items: agency[key] });
        //     }
        // })

        Object.keys(components).forEach(key => {
            let sectionItems = agency[key] || [];

            // Custom filter option
            if (components[key].filter) {
                sectionItems = components[key].filter(sectionItems);
            }
            // Custom items function
            if (components[key].itemsFunc) {
                sectionItems = components[key].itemsFunc(agency);
                console.log('', key, sectionItems)
            }
            if (components[key]?.alwaysShow || Object.keys(sectionItems).length) {
                items.push({ ...components[key], items: sectionItems, agency })
            }
        })
        return items;
    }, [isLoading])


    return (
        <ProfileLayoutWrapper sections={profileNavItems} isLoading={isLoading} type="Agency">
            <AgencyProfileDetails agency={agency}>
                {children}
            </AgencyProfileDetails>
        </ProfileLayoutWrapper>
    )
}

const ClientViewAgencyProfile = (props) => {

    const { agencyId } = useParams();
    const location = useLocation();

    const {
        data: agency,
        isFetching: isLoading,
        error,
        refetch
    } = useAPI(['fetchClient', parseInt(agencyId)], {
        enabled: !TB.isNaN(parseInt(agencyId))
    })
    if (isLoading) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <LoadingBanner message="Loading Agency" />
            </div>
        )
    }
    if (!isLoading && error) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <PageError exitLink={'/dashboard'} exitText={'Take me back'} />
            </div>)
    }

    if (!isLoading && !agency) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <ResourceNotFound type="Agency" exitLink={'/dashboard'} exitText="Return to browse" />
            </div>
        )
    }
    if (!agency) {
        return null
    }

    return (
        <Routes>
            <Route path={"*"} element={<AgencyProfileLayout agency={agency} isLoading={isLoading} />} />
            <Route path="talent-profiles/:profileId/*" element={<ClientViewTalentProfile agency={agency} />} />
        </Routes>
    )
}
export default ClientViewAgencyProfile
export {
    ClientViewAgencyProfile
}